// "Provided free by Just Attend": the one advert in the portal. SummitShield is a free
// product from Just Attend (Veronix Limited), the event management platform. Styled in
// Just Attend's own colours and type (justattend.com), so it reads as theirs, not ours.
//   <JustAttendAd />                the card (home page sidebar, help centre)
//   <JustAttendAd variant="strip" />  one line, in the footer of every page

const LINK = 'https://justattend.com/?utm_source=summitshield&utm_medium=portal&utm_campaign=provided_by';

export default function JustAttendAd({ variant = 'card' }) {
  if (variant === 'strip') {
    return (
      <div className="ja-strip">
        <img src="/justattend-logo.png" alt="Just Attend" width="92" height="33" />
        <p>SummitShield is free for every event manager, courtesy of Just Attend.</p>
        <a href={LINK} target="_blank" rel="noopener">Looking for an event platform? Find out more</a>
      </div>
    );
  }
  return (
    <aside className="ja-card" aria-label="Provided by Just Attend">
      <img src="/justattend-logo.png" alt="Just Attend" width="140" height="51" />
      <p className="ja-title">SummitShield comes to you courtesy of Just Attend</p>
      <p className="ja-text">Just Attend is the event management platform behind it: registration, ticketing, badges, exhibitors, apps and more, in one place. If you’re looking for a better way to run your events, have a look.</p>
      <a className="ja-cta" href={LINK} target="_blank" rel="noopener">See what Just Attend does</a>
    </aside>
  );
}
